<script setup lang="ts">
import type { MessageAttachmentDTO } from '@nora-monorepo/nora-api-client';
import {
  bgTertiary,
  prettyPrintFileSize,
} from '@nora-monorepo/ui-shared';

import { getIcon } from '#nora-chat-ui/utils/get-extension';

interface AttachmentFileCardProps {
  attachment: MessageAttachmentDTO;
}

defineProps<AttachmentFileCardProps>();
const emit = defineEmits<{
  open: [];
}>();
</script>

<template>
  <button
    type="button"
    class="w-96 h-96 flex justify-center flex-col rounded-xl cursor-pointer"
    :class="bgTertiary"
    @click.stop="emit('open')"
  >
    <span
      class="mi md-48 mx-auto mb-6"
      :class="[getIcon(attachment.mimeType)]"
    />
    <span class="text-xl line-clamp-3 text-center mb-3">{{
      attachment.fileName
    }}</span>
    <span class="text-s text-center">{{
      prettyPrintFileSize(attachment.size)
    }}</span>
  </button>
</template>
